import api from './api';

export const integrationsService = {
  list: () => api.get('/integrations').then((r) => r.data),
  getById: (id: number) => api.get(`/integrations/${id}`).then((r) => r.data),
  create: (data: any) => api.post('/integrations', data).then((r) => r.data),
  update: (id: number, data: any) => api.patch(`/integrations/${id}`, data).then((r) => r.data),
  delete: (id: number) => api.delete(`/integrations/${id}`).then((r) => r.data),
  sync: (id: number) => api.post(`/integrations/${id}/sync`).then((r) => r.data),
  getLogs: (id: number, page?: number, limit?: number) =>
    api.get(`/integrations/${id}/logs`, { params: { page, limit } }).then((r) => r.data),
  testConnection: (type: string, config: Record<string, any>) =>
    api.post('/integrations/test-connection', { type, config }).then((r) => r.data),
  getWebhookUrl: (id: number) => api.get(`/integrations/${id}/webhook-url`).then((r) => r.data),
};
